import Alert from "./Alert";
import { alertIcon } from "../alerts.css";
import ExclamationMark from "../../../img/icons/exclaimation-mark.svg?react";
import { ReactNode } from "react";

interface ErrorAlertProps {
  children: ReactNode;
}

const ErrorAlert = ({ children }: ErrorAlertProps) => {
  return (
    <Alert
      variant="error"
      isContentCentered
      icon={<ExclamationMark title="alert" className={alertIcon} />}
    >
      {children}
    </Alert>
  );
};

export default ErrorAlert;
